// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// defineApp
export { defineApp } from './core/defineApp'
export type { RuntimeConfig } from './core/defineApp'
// plugins
export { appCountly } from '/builds/mpc/mpc-monorepo/apps/mpc-external/src/.umi/plugin-countlyConfig';
export { appScout, captureErrorSync } from '/builds/mpc/mpc-monorepo/apps/mpc-external/src/.umi/plugin-scout';
// plugins types.d.ts
// @umijs/renderer-*
export {  } from '/builds/mpc/mpc-monorepo/packages/umi-renderer-mpc';
export type { History, ClientLoader } from '/builds/mpc/mpc-monorepo/packages/umi-renderer-mpc'
// umi/client/client/plugin
export { ApplyPluginsType, PluginManager } from '/builds/mpc/mpc-monorepo/node_modules/.pnpm/umi@4.4.11_@babel+core@7.23.7_@rspack+core@0.5.9_@swc+helpers@0.5.11__@types+node@20.4._07e25d95be794a6ce1129181a93cf590/node_modules/umi/client/client/plugin.js';
export { history, createHistory } from './core/history';
export { terminal } from './core/terminal';
// react ssr
export const useServerInsertedHTML: Function = () => {};
// test
export { TestBrowser } from './testBrowser';
